// extracted by mini-css-extract-plugin
export default {"social":"social_social__dXTyK","clockwise":"social_clockwise__0D-q-","counterclockwise":"social_counterclockwise__n4Xbj"};